import React from "react";
import { Outlet } from "react-router-dom";

export const GastLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};
